<div class="space-y-3">
  <div *ngFor="let subControl of subControls()">
    <!-- Kategorie-Header mit Anzahl -->
    <div class="flex items-baseline gap-2 pb-2 text-[#848488]">
      <span class="font-medium">{{ subControl.settings?.label }}</span>
      <span class="" *ngIf="hasIssues(subControl)">({{ getIssues(subControl).length }})</span>
    </div>
    
    <!-- Issue-Liste mit vertikaler Linie -->
    <div class="border-l border-gray-300 ml-1 pl-4 space-y-2">
      <ng-container *ngIf="hasIssues(subControl); else noIssues">
        <div *ngFor="let issue of getIssues(subControl)">
          <a 
            [nxNewTabNavigation]="['./issues/issue', issue?.id]"
            [queryParams]="{ type: 'issue', show: issue?.id }"
            class="hover:underline cursor-pointer">{{ issue.prefixedNumber }} · {{ issue.title }}</a>
          <div class="mt-1">
            <app-file-gallery-display
              [files]="getIssueFileObjects(issue)"
              [thumbnailSize]="56"
              [showDeleteButton]="false">
            </app-file-gallery-display>
          </div>
        </div>
      </ng-container>
      <ng-template #noIssues>
        <div class="text-gray-400">-</div>
      </ng-template>
    </div>
  </div>
</div>